import * as Sentry from "@sentry/react";
import {sendLogglyEvent} from "Helpers/loggly";

const sendExceptionToSentry = (error) => {
    try {
        Sentry.captureException(error);
    }catch(e){
        sendLogglyEvent('Sentry', 'Failed to send exception', e);
    }
}

export default sendExceptionToSentry;
